import { MAX_WIDTH_REFERENCE_PX, MAX_WIDTH_WINDOW_RATIO } from '../constants';

// No explicit maxWidth: cap content-wider-than-min columns at 80% of window (min 1376px reference)
export const getWindowCappedWidth = (
  width: number,
  minWidth: number | undefined
): number => {
  const minWidthPixels = minWidth ? minWidth * 13 : 0;
  if (width <= minWidthPixels) {
    return width;
  }
  const referenceWidth = Math.max(window.innerWidth, MAX_WIDTH_REFERENCE_PX);
  const cappedWidth = Math.floor(referenceWidth * MAX_WIDTH_WINDOW_RATIO);
  return cappedWidth < width ? cappedWidth : width;
};
